import { useSjActions } from '@/shared/lib/sj-orm/hooks/useSjActions';

/**
 * @deprecated Use useSjActions. Now here is not extention actions so you should use just useSjActions
 */
export const useContactsActions = () => useSjActions('contacts');
